import React from 'react';
import LegalLayout from '../components/LegalLayout';

const TermsConditions = () => (
  <LegalLayout title="Términos y Condiciones" subtitle="Legal" lastUpdated="13 de mayo de 2026">
    <p>
      Bienvenido a <strong>Teko</strong>. Los presentes Términos y Condiciones
      regulan el uso de la plataforma. Al crear una cuenta o utilizar Teko, el
      usuario acepta cumplir con todo lo establecido en este documento. En caso
      de no estar de acuerdo con alguna de las disposiciones, deberá abstenerse
      de utilizar el servicio.
    </p>

    {/* ============== LEGAL OWNER INFO (visible from T&C) ============== */}
    <div className="info-box" data-testid="owner-info-box">
      <p className="label">Responsable del servicio</p>
      <div className="row"><span className="key">Responsable:</span><span className="val">Elizabeth López Centurión</span></div>
      <div className="row"><span className="key">RUC:</span><span className="val">5930684-0</span></div>
      <div className="row"><span className="key">País de operación:</span><span className="val">Paraguay</span></div>
      <div className="row"><span className="key">Correo de contacto:</span><span className="val"><a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a></span></div>
    </div>

    <h2>1. Qué es Teko</h2>
    <p>
      Teko es una plataforma personal de productividad que incluye módulos de
      hábitos, metas con inteligencia artificial, calendario, diario, vision
      board, archivo de logros, claridad mental y presupuesto. Algunas
      funcionalidades requieren una suscripción paga.
    </p>

    <h2>2. Cuenta de usuario</h2>
    <ul>
      <li>Para utilizar Teko es necesario crear una cuenta con una dirección de correo electrónico válida.</li>
      <li>El usuario es responsable de mantener la confidencialidad de su contraseña y de toda la actividad realizada desde su cuenta.</li>
      <li>Cada cuenta es de uso exclusivo de una única persona física.</li>
      <li>Queda prohibido suplantar la identidad de terceros, automatizar el uso de la plataforma mediante bots o intentar acceder a cuentas ajenas.</li>
    </ul>

    <h2>3. Planes y suscripciones</h2>
    <p>
      Teko ofrece un plan gratuito y varios planes pagos: <strong>Light</strong>{' '}
      (3 USD/mes), <strong>Pro</strong> (7 USD/mes), <strong>Premium</strong>{' '}
      (11 USD/mes) y <strong>Trimestral</strong> (14,5 USD por 3 meses). Cada
      plan establece límites específicos en cuanto a la cantidad de tableros,
      hábitos, metas, diarios, créditos de inteligencia artificial y acceso al
      módulo Presupuesto (exclusivo del plan Premium).
    </p>
    <p>
      Los precios podrán modificarse con un preaviso mínimo de 30 días, comunicado
      a través del correo electrónico registrado. Cualquier cambio se aplicará
      en el siguiente período de facturación; los cobros vigentes no se verán
      afectados.
    </p>

    <h2>4. Pagos</h2>
    <p>
      Todos los pagos se procesan a través de un{' '}
      <strong>proveedor de servicios de pago autorizado</strong> (pasarela de
      pagos). Al suscribirse, el usuario autoriza el cobro recurrente
      automático según el plan elegido. Los datos de la tarjeta no son
      almacenados por Teko; su gestión queda a cargo del procesador de pagos
      bajo los estándares PCI-DSS.
    </p>
    <ul>
      <li>El primer cobro se efectúa al momento de la suscripción.</li>
      <li>Las renovaciones se realizan conforme al ciclo del plan elegido (mensual o trimestral).</li>
      <li>Si un pago falla, intentaremos procesarlo nuevamente durante los siguientes 7 días. Transcurrido ese plazo, la suscripción se suspenderá automáticamente y la cuenta volverá al plan gratuito.</li>
    </ul>
    <p>
      Teko podrá actualizar o cambiar el proveedor de pagos utilizado para
      procesar las suscripciones sin necesidad de modificar las condiciones
      esenciales del servicio. Cualquier cambio de proveedor no afectará los
      derechos, obligaciones ni tarifas vigentes del usuario.
    </p>

    <h2>5. Cancelación y reembolsos</h2>
    <p>
      El usuario puede cancelar su suscripción en cualquier momento desde la
      sección <strong>Membresía</strong> dentro de la plataforma. Para obtener
      información detallada sobre cancelaciones y reembolsos, consulte nuestra{' '}
      <a href="/cancelaciones">Política de Cancelaciones y Reembolsos</a>.
    </p>

    <h2>6. Uso aceptable</h2>
    <p>Queda prohibido utilizar Teko para:</p>
    <ul>
      <li>Publicar o almacenar contenido ilegal, violento, discriminatorio o que infrinja derechos de propiedad intelectual de terceros.</li>
      <li>Atacar, vulnerar o sobrecargar la infraestructura de la plataforma.</li>
      <li>Compartir la cuenta con terceros o comercializar el acceso.</li>
      <li>Extraer datos de otros usuarios mediante scraping, ingeniería inversa o cualquier técnica análoga.</li>
    </ul>
    <p>
      Nos reservamos el derecho de suspender o cerrar cuentas que infrinjan
      estas reglas, sin obligación de reembolso en los casos de uso indebido
      comprobado.
    </p>

    <h2>7. Propiedad intelectual</h2>
    <p>
      <strong>El contenido del usuario le pertenece.</strong> El usuario conserva
      la titularidad de todo el contenido que carga en Teko (textos, imágenes,
      ideas, entre otros) y puede exportarlo o eliminarlo en cualquier momento.
    </p>
    <p>
      <strong>Teko es propiedad del responsable del servicio.</strong> El
      nombre Teko, el logotipo, el código fuente, los diseños y la marca son
      propiedad del responsable del servicio identificado al inicio de este
      documento. Queda prohibida la copia, modificación o distribución de la
      plataforma sin autorización previa y por escrito.
    </p>

    <h2>8. Inteligencia artificial</h2>
    <p>
      Las funciones de inteligencia artificial (sugerencias de pasos, resúmenes,
      reflexiones del diario) son herramientas asistivas. La inteligencia
      artificial puede cometer errores o generar información inexacta.{' '}
      <strong>
        Los usuarios no deberán tomar decisiones financieras, médicas o legales
        basándose exclusivamente en respuestas generadas por la inteligencia
        artificial.
      </strong>
    </p>

    <h2>9. Limitación de responsabilidad</h2>
    <p>
      Teko se ofrece &ldquo;tal como está&rdquo;. Si bien adoptamos las medidas necesarias
      para que la plataforma funcione sin interrupciones, no garantizamos su
      disponibilidad ininterrumpida. No asumimos responsabilidad por pérdidas
      indirectas derivadas de fallas técnicas, interrupciones o errores de la
      inteligencia artificial. La responsabilidad total máxima del servicio se
      limita al monto pagado por el usuario durante los 12 meses previos al
      incidente.
    </p>

    <h2>10. Terminación</h2>
    <p>
      El usuario puede cerrar su cuenta en cualquier momento. Asimismo,
      podremos cerrar las cuentas que infrinjan los presentes términos, previa
      notificación cuando ello sea posible. Tras la terminación, los datos
      serán eliminados conforme a lo previsto en la Política de Privacidad.
    </p>

    <h2>11. Ley aplicable</h2>
    <p>
      Los presentes Términos y Condiciones se rigen por las leyes de la
      República del Paraguay. Cualquier controversia será sometida a los
      tribunales competentes de la ciudad de Asunción, Paraguay.
    </p>

    <h2>12. Modificaciones a estos términos</h2>
    <p>
      En caso de modificarse los presentes términos, se notificará al usuario
      mediante correo electrónico y se publicará la nueva versión de forma
      visible. La continuidad en el uso de la plataforma con posterioridad a
      dicha notificación implicará la aceptación de los nuevos términos.
    </p>

    <h2>13. Contacto</h2>
    <p>
      Para cualquier consulta legal o relacionada con el servicio, puede
      escribirnos a{' '}
      <a href="mailto:asistencia.teko@gmail.com">asistencia.teko@gmail.com</a>.
    </p>
  </LegalLayout>
);

export default TermsConditions;
